import type { Routes } from '@angular/router';

export const ADMIN_PANEL_ROUTES: Routes = [
  { path: '', pathMatch: 'prefix', redirectTo: 'engine' },
  {
    path: 'engine',
    loadComponent: () =>
      import('./admin-engine/admin-engine.component').then(
        (m) => m.AdminEngineComponent,
      ),
  },
];
